// TODO - Documentar
import * as con from "../../GlobalConstants"
import { EditApplicationParameterHook, StateApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { EditModelValueHook, RefModelParameterHook } from "../hooks/ModelParameterHooks"
import { UserLinesHook } from '../hooks/UserLinesHook'
import CustomNavSelect from './CustomNavSelect'

function CustomLineSelect() {
  const setPendingLineId = EditApplicationParameterHook(con.PENDING_USER_LINE_ID)
  const setShowUnsavedModal  = EditApplicationParameterHook(con.SHOW_UNSAVED_MODAL)
  const userLines = UserLinesHook()
  const [selectedLine, setSelectedUserLine] = StateApplicationParameterHook(con.SELECTED_LINE)
  const setUserLine = EditModelValueHook(con.USER_LINE)
  const modelParametersSaved = RefModelParameterHook(con.MODEL_PARAMETERS_SAVED)

  const handleChange = (e) => {
    const value = Number(e.target.value)
    if (modelParametersSaved === con.PENDING) {
      setPendingLineId(value);
      setShowUnsavedModal(true);
    } else {
        setSelectedUserLine(value)
        setUserLine(value)   
    }
  }


  return (
    <CustomNavSelect
      values={userLines.map(ob => ob[con.ID])}
      labels={userLines.map(ob => ob[con.NAME])}
      selectedValue={selectedLine}
      onChange={handleChange}
    />
  )
}

export default CustomLineSelect
